/* Ficha LED Full-Stage v18: galería, carruseles, barra fija de escritorio, fecha estimada, precarga del cotizador. Sin dependencias. */
(function () {
  if (window.__fsPdp) return; window.__fsPdp = 1; /* varias secciones lo cargan: una sola ejecución */
  var root = document.querySelector('[data-fsp]');
  if (!root) return;
  var wrap = root.parentNode;
  var rtl = getComputedStyle(root).direction === 'rtl';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* galería */
  var gal = document.getElementById('fspGal'), img = document.getElementById('fspImg'), count = document.getElementById('fspCount');
  var th = [].slice.call(root.querySelectorAll('.thumbs button')), cur = 0;
  function show(i) {
    if (!th.length || !img) return;
    cur = (i + th.length) % th.length; var b = th[cur];
    img.style.opacity = 0;
    setTimeout(function () { img.srcset = b.dataset.srcset; img.src = b.dataset.src; img.alt = b.dataset.alt; img.style.opacity = 1; }, reduce ? 0 : 120);
    th.forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
    if (count) count.textContent = (cur + 1) + ' / ' + th.length;
  }
  th.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
  if (gal) {
    gal.querySelectorAll('[data-g]').forEach(function (b) { b.addEventListener('click', function () { show(cur + (+b.dataset.g) * (rtl ? -1 : 1)); }); });
    var x0 = null;
    gal.addEventListener('pointerdown', function (e) { if (!e.target.closest('.arr')) x0 = e.clientX; });
    gal.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + ((dx < 0) !== rtl ? 1 : -1)); });
    gal.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(cur + (rtl ? -1 : 1)); if (e.key === 'ArrowLeft') show(cur + (rtl ? 1 : -1)); });
  }

  /* galería = alto de la columna de compra en todas las fichas (más corta o más larga): las dos columnas miden lo mismo
     y el scroll no se descompensa. Alto de la galería = g (foto cuadrada) + 12 (separación) + (g − 50) / 6 (miniaturas)
     → g = (alto − 12 + 50/6) · 6/7, entre 300 px y el ancho de su columna. */
  var buyEl = root.querySelector('.buy'), galEl = root.querySelector('.gal');
  function fitGal() {
    if (!buyEl || !galEl) return;
    galEl.style.removeProperty('--g');
    if (innerWidth <= 760) return;
    var colW = galEl.getBoundingClientRect().width;
    var fit = (buyEl.getBoundingClientRect().height - 12 + 50 / 6) * 6 / 7;
    galEl.style.setProperty('--g', Math.floor(Math.min(colW, Math.max(300, fit))) + 'px');
  }
  fitGal(); addEventListener('resize', fitGal); addEventListener('load', fitGal);
  if ('ResizeObserver' in window && buyEl) new ResizeObserver(fitGal).observe(buyEl);

  /* carruseles: flechas que avanzan una tarjeta y se ocultan en los extremos */
  /* las secciones fs-led-* van cada una en su .fsp-wrap: los carruseles se buscan en todas (2026-10-13) */
  document.querySelectorAll('.fsp-wrap .car').forEach(function (c) {
    var t = c.querySelector('.trk'), p = c.querySelector('.arr.prev'), n = c.querySelector('.arr.next');
    if (!t || !p || !n) return;
    var dirR = getComputedStyle(t).direction === 'rtl' ? -1 : 1;
    function step() { var f = t.children[0]; return f ? f.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 12) : 300; }
    /* José, 13-10: la flecha de la derecha mueve siempre hacia la derecha y la de la izquierda hacia la izquierda, también en árabe.
       En árabe la serie empieza a la derecha: al inicio se oculta la flecha derecha (no hay nada más a ese lado). */
    function upd() { var s = Math.abs(t.scrollLeft), ini = s < 4, fin = s + t.clientWidth >= t.scrollWidth - 4;
      p.hidden = dirR < 0 ? fin : ini; n.hidden = dirR < 0 ? ini : fin; }
    p.onclick = function () { t.scrollBy({ left: -step() }); };
    n.onclick = function () { t.scrollBy({ left: step() }); };
    t.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd);
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(t);
    upd();
  });

  /* cifras de opiniones: mismo contador que fs-inspections-process (1,2 s, una vez al entrar en vista) */
  var cs = root.querySelectorAll('[data-fsi-target]');
  if (cs.length && !reduce && 'IntersectionObserver' in window) {
    var ease = function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; };
    cs.forEach(function (el) {
      var raw = el.dataset.fsiTarget || '', sep = raw.indexOf(',') > -1 ? ',' : '.', tg = parseFloat(raw.replace(',', '.'));
      if (isNaN(tg)) return;
      var d = (raw.split(/[.,]/)[1] || '').length, sf = el.dataset.fsiSuffix || '';
      var fmt = function (v) { return v.toFixed(d).replace('.', sep) + sf; };
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        (function step(ts) { if (!t0) t0 = ts; var r = Math.min((ts - t0) / 1200, 1); el.textContent = fmt(tg * ease(r)); if (r < 1) requestAnimationFrame(step); else el.textContent = fmt(tg); })(performance.now());
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* «Ver más» de «en detalle» (en móvil el resto del texto empieza plegado) */
  root.querySelectorAll('[data-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.getElementById(b.dataset.more), o = t.classList.toggle('open');
      b.setAttribute('aria-expanded', String(o)); b.textContent = o ? b.dataset.lLess : b.dataset.lMore;
    });
  });

  /* videos: uno a la vez */
  root.addEventListener('play', function (e) { root.querySelectorAll('video').forEach(function (v) { if (v !== e.target) v.pause(); }); }, true);

  /* ficha técnica: abierta en escritorio, plegada en móvil */
  var sd = root.querySelector('.specs-d');
  if (sd) { var mq = matchMedia('(max-width: 760px)'); var sync = function () { sd.open = !mq.matches; }; sync(); mq.addEventListener && mq.addEventListener('change', sync); }

  /* barra fija de escritorio cuando el botón principal sale de la vista */
  var sb = document.getElementById('fspSbar'), cta = root.querySelector('.buy .cta');
  if (sb && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sb.classList.toggle('on', on); sb.setAttribute('aria-hidden', String(!on));
      var a = sb.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
    }).observe(cta);
  }

  /* fecha estimada de llegada en el idioma del visitante */
  wrap.querySelectorAll('[data-fsp-eta]').forEach(function (el) {
    var d = new Date(Date.now() + (+el.dataset.fspEta) * 864e5);
    try { el.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { day: 'numeric', month: 'long' }).format(d); } catch (_) { el.textContent = d.toLocaleDateString(); }
  });

  /* precarga del cotizador: medida, pitch, entorno y estructura elegida en esta ficha */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.fsp-wrap a[href$="#cotizar"]');
    if (!a) return;
    var st = a.hasAttribute('data-structure') ? { value: a.getAttribute('data-structure'), dataset: {} } : root.querySelector('input[name="fsp_st"]:checked, input[name="fx_st"]:checked') /* fx_st = compra v64; data-structure = tarjeta sin kit que abre la propuesta */;
    try {
      sessionStorage.setItem('fs_quote_prefill', JSON.stringify({
        w: parseFloat(root.dataset.w) || null, h: parseFloat(root.dataset.h) || null,
        pitch: root.dataset.pitch || null, env: root.dataset.env || null, from: root.dataset.handle,
        structure: st ? st.value : null, structure_handle: st && st.dataset.handle || null,
        proposal: a.hasAttribute('data-fsp-quote'), at: Date.now()
      }));
    } catch (_) {}
  }, true);

  /* WhatsApp: mismo evento que la isla */
  wrap.querySelectorAll('[data-fsp-wa]').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = { fs_source: 'pdp', page_type: 'product' };
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'fs_whatsapp' }, d)); } catch (_) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('fs_whatsapp', d); } catch (_) {}
    });
  });
})();
